export enum ResultVisualizationType {
    Unknown = 0,
    RadarChart = 1,
    BarChart = 2,
    ScorePercentage = 3
}
